import { DataHeader, DataSourceMode, DataSourceModeChangeEvent } from "@mcleod/components";
import { AutogenLayoutGLAssignmentMaster } from "./autogen/AutogenLayoutGLAssignmentMaster";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

const viewGLAssignmentURL = "lme/dispatch/GLAssignmentMaster?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName:"gl_assignment",
    screenName:"GLAssignmentMaster",
    navigateToUrl:viewGLAssignmentURL,
    altFieldNameForDupCheck: "gla_code",
    primaryKeyFieldNameForAlt: "gla_uid",
};
export class GLAssignmentMaster extends AutogenLayoutGLAssignmentMaster {

    override onLoad() {
        DuplicateId.configureIdTextbox(this.textboxGlaCode, DUPLICATE_VALIDATION_PROPS);
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.promptToSaveChanges();
    }

    sourceGlAssignmentAfterModeChange(event: DataSourceModeChangeEvent) {
        if (event.newMode === DataSourceMode.UPDATE) {
            this.textboxGlaCode.enabled = false;
        }
    }
}
